{
  "familyId": "TAA-SOORT-VZ",
  "questions": [
    {
      "id": "TAA-SOORT-VZ-001",
      "familyId": "TAA-SOORT-VZ",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voorzetsel",
      "questionType": "multiple_choice",
      "question": "Welk woord is een voorzetsel in de zin: 'De kat springt over het hek.'?",
      "options": ["over", "springt", "het", "hek"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Voorzetsel herkennen", "content": "Een voorzetsel geeft een relatie aan: plaats (op, in, onder, naast), richting (naar, over, door), of tijd (na, voor, tijdens). Het staat altijd vóór een zelfstandig naamwoord.", "icon": "lightbulb"}}],
      "conceptId": "voorzetsel_herkennen",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.verb-as-preposition", "label": "Verwart werkwoord met voorzetsel", "optionIndex": 1 },
          { "id": "taa.article-as-preposition", "label": "Verwart lidwoord met voorzetsel", "optionIndex": 2 },
          { "id": "taa.noun-as-preposition", "label": "Verwart zelfstandig naamwoord met voorzetsel", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "'Over' is het voorzetsel. Het geeft de richting aan: de kat springt OVER het hek. Een voorzetsel staat vóór een zelfstandig naamwoord en geeft een relatie aan (plaats, richting, of tijd).",
        "solutionSteps": ["Zoek het woord dat een relatie aangeeft (plaats/richting/tijd)", "'Over' geeft richting aan: over het hek", "'Over' staat vóór 'het hek' → het is een voorzetsel"],
        "distractorExplanations": {
          "0": "Goed! 'Over' is het voorzetsel. Het geeft de richting aan.",
          "1": "Je dacht waarschijnlijk dat het werkwoord werd gevraagd. 'Springt' is de persoonsvorm, geen voorzetsel. Onthoud: een voorzetsel geeft een relatie aan (plaats, richting, tijd).",
          "2": "Je dacht waarschijnlijk dat het lidwoord werd gevraagd. 'Het' is een lidwoord, geen voorzetsel. Onthoud: een voorzetsel geeft aan WAAR, WAARHEEN of WANNEER iets is.",
          "3": "Je dacht waarschijnlijk dat het zelfstandig naamwoord werd gevraagd. 'Hek' is een zelfstandig naamwoord. Het voorzetsel staat er juist VÓÓR: 'over het hek'."
        }
      }
    },
    {
      "id": "TAA-SOORT-VZ-002",
      "familyId": "TAA-SOORT-VZ",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voorzetsel",
      "questionType": "multiple_choice",
      "question": "Hoeveel voorzetsels staan er in de zin: 'Na de les liep ik met mijn vriend naar het park.'?",
      "options": ["3", "2", "4", "1"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Meerdere voorzetsels in een zin", "content": "Een zin kan meerdere voorzetsels bevatten. Zoek alle woorden die een relatie aangeven: NA (tijd), MET (samen), NAAR (richting).", "icon": "lightbulb"}}],
      "conceptId": "voorzetsel_tellen",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.miss-preposition-count", "label": "Telt niet alle voorzetsels", "optionIndex": 1 },
          { "id": "taa.overcount-prepositions", "label": "Telt niet-voorzetsels mee", "optionIndex": 2 },
          { "id": "taa.miss-preposition-count", "label": "Telt niet alle voorzetsels", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Er zijn 3 voorzetsels: 'na' (tijd: na de les), 'met' (samen: met mijn vriend), en 'naar' (richting: naar het park).",
        "solutionSteps": ["Zoek woorden die een relatie aangeven:", "'Na' de les → tijd → voorzetsel ✓", "'Met' mijn vriend → samen → voorzetsel ✓", "'Naar' het park → richting → voorzetsel ✓", "Totaal: 3 voorzetsels"],
        "distractorExplanations": {
          "0": "Goed! 'Na', 'met' en 'naar' zijn alle drie voorzetsels.",
          "1": "Je hebt er waarschijnlijk één gemist. Kijk nog eens: 'na' (tijd), 'met' (samen), 'naar' (richting). Alle drie zijn voorzetsels. Onthoud: voorzetsels geven plaats, richting, tijd, of manier aan.",
          "2": "Je hebt waarschijnlijk een lidwoord of bijwoord meegeteld. 'De', 'het' en 'mijn' zijn geen voorzetsels. Onthoud: een voorzetsel geeft een relatie aan, een lidwoord staat bij een zelfstandig naamwoord.",
          "3": "Je hebt er waarschijnlijk twee gemist. 'Na', 'met' en 'naar' zijn alle drie voorzetsels. Onthoud: zoek alle woorden die aangeven WAAR, WANNEER, WAARHEEN of met WIE."
        }
      }
    },
    {
      "id": "TAA-SOORT-VZ-003",
      "familyId": "TAA-SOORT-VZ",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voorzetsel",
      "questionType": "multiple_choice",
      "question": "Welk woord is GEEN voorzetsel?",
      "options": ["snel", "onder", "tussen", "tijdens"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Voorzetsel vs. bijwoord", "content": "'Snel' beschrijft HOE iets gebeurt → bijwoord. 'Onder', 'tussen' en 'tijdens' geven een relatie aan (plaats of tijd) → voorzetsels.", "icon": "lightbulb"}}],
      "conceptId": "voorzetsel_vs_bijwoord",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.preposition-as-non-preposition", "label": "Denkt dat een voorzetsel geen voorzetsel is", "optionIndex": 1 },
          { "id": "taa.preposition-as-non-preposition", "label": "Denkt dat een voorzetsel geen voorzetsel is", "optionIndex": 2 },
          { "id": "taa.preposition-as-non-preposition", "label": "Denkt dat een voorzetsel geen voorzetsel is", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "'Snel' is een bijwoord — het beschrijft HOE iets gebeurt. 'Onder', 'tussen' en 'tijdens' zijn voorzetsels: ze geven een relatie aan (plaats of tijd).",
        "solutionSteps": ["Test elk woord: geeft het een relatie aan (plaats/richting/tijd)?", "'Snel' → beschrijft hoe → bijwoord, GEEN voorzetsel", "'Onder' → plaats → voorzetsel ✓", "'Tussen' → plaats → voorzetsel ✓", "'Tijdens' → tijd → voorzetsel ✓"],
        "distractorExplanations": {
          "0": "Goed! 'Snel' is een bijwoord, geen voorzetsel. Het beschrijft hoe iets gebeurt.",
          "1": "Je dacht waarschijnlijk dat 'onder' geen voorzetsel is. Maar 'onder de tafel' geeft een plaats aan → voorzetsel. Onthoud: voorzetsels geven relaties aan.",
          "2": "Je dacht waarschijnlijk dat 'tussen' geen voorzetsel is. Maar 'tussen de bomen' geeft een plaats aan → voorzetsel.",
          "3": "Je dacht waarschijnlijk dat 'tijdens' geen voorzetsel is. Maar 'tijdens de les' geeft een tijd aan → voorzetsel."
        }
      }
    },
    {
      "id": "TAA-SOORT-VZ-004",
      "familyId": "TAA-SOORT-VZ",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voorzetsel",
      "questionType": "multiple_choice",
      "question": "Welk type relatie geeft het voorzetsel 'tijdens' aan in: 'Tijdens het eten praatten we.'?",
      "options": ["tijd", "plaats", "richting", "manier"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Soorten voorzetsels", "content": "Voorzetsels geven verschillende relaties aan: TIJD (na, voor, tijdens, sinds), PLAATS (op, in, onder, naast), RICHTING (naar, over, door), MANIER (met, zonder).", "icon": "lightbulb"}}],
      "conceptId": "voorzetsel_soort_relatie",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.preposition-place-as-time", "label": "Verwart plaatsvoorzetsel met tijdsvoorzetsel", "optionIndex": 1 },
          { "id": "taa.preposition-direction-as-time", "label": "Verwart richtingsvoorzetsel met tijdsvoorzetsel", "optionIndex": 2 },
          { "id": "taa.preposition-manner-as-time", "label": "Verwart maniervoorzetsel met tijdsvoorzetsel", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "'Tijdens' geeft een tijdsrelatie aan: WANNEER praatten we? → tijdens het eten. Andere tijdsvoorzetsels zijn: na, voor, sinds, tot.",
        "solutionSteps": ["Stel de vraag: wat geeft 'tijdens' aan?", "'Tijdens het eten' → WANNEER? → tijd", "Dus 'tijdens' is een voorzetsel van tijd"],
        "distractorExplanations": {
          "0": "Goed! 'Tijdens' geeft een tijdsrelatie aan: wanneer praatten we? → tijdens het eten.",
          "1": "Je dacht waarschijnlijk dat 'tijdens' een plaats aangeeft. Maar 'tijdens' beantwoordt de vraag WANNEER, niet WAAR. Onthoud: 'op de tafel' = plaats, 'tijdens de les' = tijd.",
          "2": "Je dacht waarschijnlijk dat 'tijdens' een richting aangeeft. Maar richting-voorzetsels zijn woorden als 'naar', 'over', 'door'. 'Tijdens' gaat over tijd.",
          "3": "Je dacht waarschijnlijk dat 'tijdens' een manier aangeeft. Maar manier-voorzetsels zijn woorden als 'met' en 'zonder'. 'Tijdens' gaat over tijd."
        }
      }
    },
    {
      "id": "TAA-SOORT-VZ-005",
      "familyId": "TAA-SOORT-VZ",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voorzetsel",
      "questionType": "matching",
      "question": "Koppel elk voorzetsel aan het type relatie dat het aangeeft.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["onder", "naar", "tijdens", "met"],
        "rightItems": ["richting", "plaats", "manier", "tijd"],
        "correctMatches": { "0": 1, "1": 0, "2": 3, "3": 2 }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Voorzetsels en relaties", "content": "Maak een voorbeeldzin: 'onder de tafel' (WAAR? → plaats), 'naar school' (WAARHEEN? → richting), 'tijdens de les' (WANNEER? → tijd), 'met een pen' (HOE? → manier).", "icon": "lightbulb"}}],
      "conceptId": "voorzetsel_relatie_koppelen",
      "variantIndex": 5,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "'Onder' → plaats (WAAR?), 'naar' → richting (WAARHEEN?), 'tijdens' → tijd (WANNEER?), 'met' → manier (HOE?).",
        "solutionSteps": ["'Onder de tafel' → WAAR? → plaats", "'Naar school' → WAARHEEN? → richting", "'Tijdens de les' → WANNEER? → tijd", "'Met een pen' → HOE? → manier"]
      }
    },
    {
      "id": "TAA-SOORT-VZ-006",
      "familyId": "TAA-SOORT-VZ",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voorzetsel",
      "questionType": "categorize",
      "question": "Sorteer de voorzetsels: geven ze een plaats, richting of tijd aan?",
      "data": {
        "categories": ["Plaats", "Richting", "Tijd"],
        "items": [
          { "text": "op", "correctCategory": 0 },
          { "text": "naar", "correctCategory": 1 },
          { "text": "tijdens", "correctCategory": 2 },
          { "text": "onder", "correctCategory": 0 },
          { "text": "door", "correctCategory": 1 },
          { "text": "na", "correctCategory": 2 },
          { "text": "tussen", "correctCategory": 0 },
          { "text": "voor", "correctCategory": 2 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Soorten voorzetsels",
            "content": "Plaats: op, in, onder, naast, tussen, bij, achter. Richting: naar, door, over, langs, uit. Tijd: na, voor, tijdens, sinds, tot. Vraag: geeft het woord aan WAAR, WAARHEEN of WANNEER?",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voorzetsel_categoriseer_type",
      "variantIndex": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Voorzetsels geven een relatie aan. Plaats (waar?): op, onder, tussen. Richting (waarheen?): naar, door. Tijd (wanneer?): tijdens, na, voor.",
        "solutionSteps": [
          "Vraag bij elk voorzetsel: geeft het aan WAAR, WAARHEEN of WANNEER?",
          "Plaats → op, onder, tussen",
          "Richting → naar, door",
          "Tijd → tijdens, na, voor"
        ]
      }
    },
    {
      "id": "TAA-SOORT-VZ-007",
      "familyId": "TAA-SOORT-VZ",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voorzetsel",
      "questionType": "categorize",
      "question": "Welke woorden zijn voorzetsels en welke zijn bijwoorden?",
      "data": {
        "categories": ["Voorzetsel", "Bijwoord"],
        "items": [
          { "text": "in", "correctCategory": 0 },
          { "text": "snel", "correctCategory": 1 },
          { "text": "naast", "correctCategory": 0 },
          { "text": "graag", "correctCategory": 1 },
          { "text": "achter", "correctCategory": 0 },
          { "text": "altijd", "correctCategory": 1 },
          { "text": "sinds", "correctCategory": 0 },
          { "text": "vaak", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voorzetsel vs. bijwoord",
            "content": "Een voorzetsel staat VÓÓR een zelfstandig naamwoord en geeft een relatie aan (in de kast, naast het huis). Een bijwoord beschrijft HOE, WANNEER of HOE VAAK iets gebeurt (snel, graag, altijd, vaak).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voorzetsel_vs_bijwoord_categoriseer",
      "variantIndex": 7,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Voorzetsels (in, naast, achter, sinds) staan vóór een zelfstandig naamwoord en geven een relatie aan. Bijwoorden (snel, graag, altijd, vaak) beschrijven hoe of wanneer iets gebeurt.",
        "solutionSteps": [
          "Test: kan het woord vóór een zelfstandig naamwoord staan? (in de kast, naast het huis)",
          "Ja → voorzetsel",
          "Nee, het beschrijft hoe/wanneer → bijwoord"
        ]
      }
    },
    {
      "id": "TAA-SOORT-VZ-008",
      "familyId": "TAA-SOORT-VZ",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voorzetsel",
      "questionType": "true_false_series",
      "question": "Beoordeel elke bewering over voorzetsels.",
      "data": {
        "statements": [
          { "text": "'Op' is een voorzetsel van plaats.", "isTrue": true },
          { "text": "'Snel' is een voorzetsel.", "isTrue": false },
          { "text": "Een voorzetsel staat altijd vóór een zelfstandig naamwoord.", "isTrue": true },
          { "text": "'Naar' geeft een tijdsrelatie aan.", "isTrue": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Voorzetsels controleren", "content": "Voorzetsels geven relaties aan: plaats (op, in), richting (naar, door), tijd (na, tijdens). Ze staan vóór een zelfstandig naamwoord. 'Snel' is een bijwoord, geen voorzetsel.", "icon": "lightbulb" } }
      ],
      "conceptId": "voorzetsel_waar_onwaar",
      "variantIndex": 8,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "'Op' is inderdaad een plaatsvoorzetsel (op de tafel). 'Snel' is een bijwoord, geen voorzetsel. Voorzetsels staan inderdaad vóór een zelfstandig naamwoord. 'Naar' geeft richting aan, niet tijd.",
        "solutionSteps": [
          "'Op' = plaatsvoorzetsel ✓ (waar)",
          "'Snel' = bijwoord, geen voorzetsel (onwaar)",
          "Voorzetsel staat vóór znw ✓ (waar)",
          "'Naar' = richting, niet tijd (onwaar)"
        ]
      }
    }
  ]
}